var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-row',{attrs:{"gutter":5}},[_c('el-col',{attrs:{"xs":12,"sm":8,"md":8,"lg":6,"xl":6}},[_c('BilletExcelObjectsLine')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }